// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6135":"8c3c764b","7035":"8c3c764b","8817":"eef39072","9741":"8c3c764b","9971":"eef39072"}[chunkId] + ".chunk.css";
};